import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AnimatedRoutes from './components/AnimatedRoutes';
import Header from './components/Header';
import ScrollToTopButton from './components/ScrollToTopButton';
import { TransitionProvider } from './contexts/TransitionContext';
import AnalyticsTracker from './analytics/AnalyticsTracker';

function App() {
  return (
    <Router>
      <TransitionProvider>
        <div className="App">
          <AnalyticsTracker />
          <Header />
          <AnimatedRoutes />
          <ScrollToTopButton />
        </div>
      </TransitionProvider>
    </Router>
  );
}

export default App;
